import { signal, computed } from '@preact/signals';
import type { User, Client, Visit, Tenant, TenantSummary, SmtpConfig } from '../api/types';

export const token = signal<string | null>(localStorage.getItem('token'));
export const user = signal<User | null>(
  JSON.parse(localStorage.getItem('user') || 'null')
);
export const tenant = signal<TenantSummary | null>(
  JSON.parse(localStorage.getItem('tenant') || 'null')
);

export const visits = signal<Visit[]>([]);
export const clients = signal<Client[]>([]);
export const tecnicos = signal<User[]>([]);
export const admins = signal<User[]>([]);
export const tenants = signal<Tenant[]>([]);
export const smtpConfig = signal<SmtpConfig | null>(null);

export const currentVisit = signal<Visit | null>(null);
export const currentClient = signal<Client | null>(null);
export const clientVisits = signal<Visit[]>([]);

export const searchQuery = signal('');
export const filterEstado = signal('');
export const editId = signal<string | null>(null);

export const loading = signal(false);
export const dataLoading = signal(false);
export const error = signal<string | null>(null);
export const success = signal<string | null>(null);

export const isAdmin = computed(() => user.value?.rol === 'admin');
export const isSuperadmin = computed(() => user.value?.rol === 'superadmin');

export const windowWidth = signal(window.innerWidth);
window.addEventListener('resize', () => {
  windowWidth.value = window.innerWidth;
});

export const isDesktop = computed(() => windowWidth.value > 768);
export const isDesktopAdmin = computed(() => (isAdmin.value || isSuperadmin.value) && isDesktop.value);

export function clearError() {
  error.value = null;
}
